export default [
    {
        path: 'grupo',
        component: () => import(
            '@/views/transporte-paciente/grupo/Index'
        ),
        redirect: 'grupo/list',
        children: [
            {
                name: 'transporte-paciente-grupo-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/grupo/List'
                ),
            },
            {
                name: 'transporte-paciente-grupo-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/grupo/Form'
                ),
            },
            {
                name: 'transporte-paciente-grupo-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/grupo/Form'
                ),
            },
        ],
    },
]